import React from "react";
import { Alert, AlertDescription } from "components/ui/alert";

interface Menu {
  menu_key: string;
  menu_desc: string;
  icon_name: string;
  has_access: boolean;
  display_order: number;
  parent_menu_key?: string;
  submenu?: Menu[];
}

interface MenuAction {
  action_key: string;
  action_desc: string;
  has_access: boolean;
}

interface MenuTabProps {
  menusLoading: boolean;
  menusError: string;
  roleMenus: Menu[];
  renderMenuItem: (menu: Menu, isSubmenu?: boolean) => React.ReactNode;
}

const MenuTab: React.FC<MenuTabProps> = ({
  menusLoading,
  menusError,
  roleMenus,
  renderMenuItem,
}) => {
  if (menusLoading)
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-500"></div>
      </div>
    );

  if (menusError)
    return (
      <Alert variant="destructive">
        <AlertDescription>{menusError}</AlertDescription>
      </Alert>
    );

  return (
    <div className="space-y-2 h-full overflow-y-auto">
      {roleMenus.length === 0 ? (
        <div className="text-center py-8 text-gray-500">No menus available for this role</div>
      ) : (
        roleMenus
          .sort((a, b) => a.display_order - b.display_order)
          .map((menu) => (
            <div key={menu.menu_key} className="space-y-2">
              {renderMenuItem(menu)}
              {menu.submenu &&
                menu.submenu.length > 0 &&
                menu.submenu
                  .sort((a, b) => a.display_order - b.display_order)
                  .map((sub) => renderMenuItem(sub, true))}
            </div>
          ))
      )}
    </div>
  );
};

export default MenuTab;